<template>
  <section class="page-container">
    <div>
      <h1>Extra Benefits</h1>
      <div
        class="btn-top-container">
        <v-button
          type="plain"
          size="mini"
          @click="handlerToExportList"
        >Export List
        </v-button>
        <v-button
          type="plain"
          size="mini"
          :disabled="!date"
          @click="handlerDown"
        >Export Excel
        </v-button>
      </div>
    </div>
    <div class="filter-card">
      <div class="filter-top">
        <span>Search</span>
        <v-input
          v-model="search"
          placeholder="Ref., Certificate No., Customer Name, Contact, ID No."
          @keyEnter="filterData" />
      </div>
      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Creation Date</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="changeDate" />
          </div>
          <div class="form-item">
            <span>Assignee</span>
            <span>
              <v-select
                v-model="cs_id"
                icon="user-nurse"
                :clearable="true"
                :list="assgineeList"
                @change="filterData" />
            </span>
          </div>
          <div class="form-item">
            <span>
              Insurer
              <span
                class="all"
                @click="handlerSelectAll('company_id')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('company_id')">None</span>
            </span>
            <v-checkbox-group
              v-model="company_id"
              :list="companyList"
              :isColumn="false"
              @change="filterData"
            />
          </div>
          <div class="form-item">
            <span>
              Channel
              <span
                class="all"
                @click="handlerSelectAll('source')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('source')">None</span>
            </span>
            <span>
              <v-checkbox-group
                v-model="source"
                :list="channelList"
                :isColumn="false"
                @change="filterData"
              />
            </span>
          </div>
        </div>
        <div class="filter-middler">
          <div class="form-item">
            <span>
              Product Type
              <span
                class="all"
                @click="handlerSelectAll('product_id')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('product_id')">None</span>
            </span>
            <div class="flex-sb">
              <div>
                <v-checkbox-group
                  v-model="product_id"
                  :list="productList"
                  :isColumn="false"
                  @change="filterData"></v-checkbox-group>
              </div>
            </div>
          </div>
        </div>
        <div class="filter-right">
          <div class="form-item">
            <span>
              Status
              <span
                class="all"
                @click="handlerSelectAll('stts')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('stts')">None</span>            </span>
            <v-checkbox-group
              v-model="stts"
              :list="statusOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="circle"
                    :class="{
                      'red': item.id == 0,
                      'orange-light': item.id == 1,
                      'yellow-dark': item.id == 2,
                      'blue': item.id == 3,
                      'green': item.id == 4
                    }"></span>
                  <span>{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
          <div class="form-item">
            <span>
              Effectiveness
              <span
                class="all"
                @click="handlerSelectAll('effe')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('effe')">None</span>            </span>
            <v-checkbox-group
              v-model="effe"
              :list="effeOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="span-options"
                    :class="{
                      'gray': item.id == 1,
                      'green': item.id == 2,
                      'red': item.id == 3
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
        <!--        <div class="filter-last">-->
        <!--          <div class="form-item">-->
        <!--            <span>-->
        <!--              Tags-->
        <!--              <span-->
        <!--                class="all"-->
        <!--                @click="handlerSelectAll('tags')">All</span>-->
        <!--              <span-->
        <!--                class="all"-->
        <!--                @click="handlerNoneAll('tags')">None</span>            </span>-->
        <!--            <v-checkbox-group-->
        <!--              v-model="tags"-->
        <!--              :list="tagsOptions"-->
        <!--              :isColumn="false"-->
        <!--              @change="filterData">-->
        <!--              <template #default="{ item }">-->
        <!--                <span class="flex">-->
        <!--                  <span-->
        <!--                    class="span-options"-->
        <!--                    :class="{-->
        <!--                      'gold': item.id == 1,-->
        <!--                      'blue': [2,16,64,1024].includes(item.id),-->
        <!--                      'orange': item.id == 4,-->
        <!--                      'black': [8,32,128,256].includes(item.id),-->
        <!--                      'red': [512,4096].includes(item.id)-->
        <!--                    }">{{ item['name'] }}</span>-->
        <!--                </span>-->
        <!--              </template>-->
        <!--            </v-checkbox-group>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>

    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="'table-pointer'"
        :header-row-class-name="'tableHeader'"
        @row-click="rowClick">
        <el-table-column
          width="69px"
          align="center">
          <template #default="{row}">
            <div
              class="flex-algin"
            >
              <p class="icon icon-text">
                <font-awesome-icon
                  icon="file-powerpoint"
                  class="icon-color"
                  :class="{
                    'gray': row.effectiveness == 1,
                    'green': row.effectiveness == 2,
                    'red': row.effectiveness == 3
                  }"/>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="85px"
          label="Updated">
          <template #default="{ row }">
            <div
              v-if="row.sort_time"
              class="flex-algin time-text">
              <!--              <span>-->
              <span>{{ row.sort_time.split(" ")[0] }}</span><br>
              <span> {{ row.sort_time.split(" ")[1] }}</span>
              <!--              </span>-->
            </div>
          </template>

        </el-table-column>
        <el-table-column
          width="70"
          prop="id"
        >
          <template #default="{ row }">
            <!--            <span class="button-border">{{row.type_language}}</span>-->
            <div class="flex-algin">
              <span>
                <div class="flex  table-icon">
                  <div>
                    <span
                      v-tooltip="row.company_language"
                      class="icon icon-content"
                    >
                      <img
                        :src="getOptionData('companySmallIcon', row.company_id).logo? getOptionData('companySmallIcon', row.company_id).logo: row.company_logo"
                      >
                    </span>
                  </div>
                  <div v-if="[2].includes(row.benefit_nid)">
                    <span
                      class="icon icon-content backgroud-width"
                    >
                      <font-awesome-icon
                        icon="wind" />
                    </span>
                  </div>
                  <div   v-if="[1].includes(row.benefit_nid)">
                    <span
                      class="icon icon-content backgroud-width"
                    >
                      <font-awesome-icon
                        icon="user-injured" />
                    </span>
                  </div>
                  <div v-if="[4].includes(row.benefit_nid)">
                    <span
                      class="icon icon-content backgroud-width"
                    >
                      <font-awesome-icon
                        icon="key" />
                    </span>
                  </div>
                  <!--                  <div>-->
                  <!--                    <span-->
                  <!--                      v-tooltip="row.class_language"-->
                  <!--                      class="icon icon-content"-->
                  <!--                    >-->
                  <!--                      <font-awesome-icon-->
                  <!--                        v-if="row.class_id"-->
                  <!--                        :icon="getOptionName('iconOptions', row.class_id)" />-->
                  <!--                    </span>-->
                  <!--                  </div>-->
                </div>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Plan Name">
          <template #default="{ row }">
            <div @click="rowClick(row)">
              <router-link
                :to="clickPlanName(row)"
                class="flex-algin no-line">
                <span class="span-label">{{row.name}}</span>
                <p class="phone-text">
                  <template><span class="weight-text">Policy No. </span> {{ row.pcy_no }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</template>
                  <template><span class="weight-text">Certificate  </span> {{ row.ci_no }}&nbsp;&nbsp;&nbsp;</template>
                </p>
                <span
                  v-if="row.order_sn"
                  class="phone-text">
                  <template><span class="weight-text"> Ref. </span>{{ row.order_sn }}</template>
                </span>
              </router-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="105px"
          label="Summary">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="first-text summary">{{ row.description }} </p>
              <span v-if="row.rgtn_no">
                <span class="summary_rgtn_no">{{ row.rgtn_no }} </span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="105px"
          label="Policyholder">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="span-name">{{ row.isrd_nm }}</span>
              <span>
                <span class="phone-text"> {{ row.mobile_no }}</span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="95"
          prop=""
          label="Period">
          <template #default="{ row }">
            <div
              v-if="row.period"
              class="flex-algin period-text">
              <span>{{ row.period.split(" - ")[0] }}&nbsp;-</span><br>
              <span> {{ row.period.split(" - ")[1] }}</span>
            </div>
          </template>

        </el-table-column>
        <el-table-column
          width="155px"
          :show-overflow-tooltip="true"
          label="Status">
          <template #default="{ row }">
            <div class="flex-algin status-height">
              <p>
                <span
                  class="span-status"
                  :class="{
                    'red': [801, 0].includes(row.pcy_stts),
                    'orange': [401, 301].includes(row.pcy_stts),
                    'yellow-dark': [410, 501, 701].includes(row.pcy_stts),
                    'blue': [420, 505, 705].includes(row.pcy_stts),
                    'green': [425, 510, 710].includes(row.pcy_stts)
                  }">
                  {{ row.pcy_stts_language }}
                </span>
              </p>
              <p
                v-for="(v,i) in row.tag_language"
                :key="i">
                <span
                  class="span-options"
                  :class="{
                    'gold': v.id == 1,
                    'blue': [2,16,64].includes(v.id),
                    'orange': v.id == 4,
                    'black': [8,32,128].includes(v.id),
                    'red': [4096,8192].includes(v.id)
                  }">{{v.name}}</span>
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>


    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {getExtraBenefitsList,getExtraBenefitsExportList} from '@api/policy'
import {downloadFile} from '@/utils/download'
import MixinOptions from '@/mixins/options'

export default {
  name: 'extraBenefitList',
  mixins: [MixinOptions],
  data() {
    return{
      exportDisable: true,
      active: 'Micropolicies',
      campaignList:[
        {
          id: 1,
          name: 'HoldCover'
        },
        {
          id: 2,
          name: 'WM-Hotel'
        },
      ],
      statusList:[
        {
          id:425,
          name:'New Policy'
        },
        {
          id:801,
          name:'Expired'
        },
        {
          id:0,
          name:'Void'
        }
      ],
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      // todo
      date: '',
      company_id: [],
      product_id: [],
      campaign_id: [],
      category_id: [],
      stts: [1,2,3,4],
      effe: [1,2],
      tags: [],
      cs_id:'',
      search: '',
      tableData: [],
      paymentNum: 0,
      has_img:'',
      source: [],
    }
  },
  computed:{
    ...mapState('filter', ['selectFilterData']),
    channelList(){
      return [
        {
          id:1,
          name:'Web'
        },
        {
          id:4,
          name:'AlipayHK'
        }
      ]
    },
    isDisable(){
      return !this.date
    },
    companyList(){
      let {extra_benefit_companys} = this.globalOptions||{}
      return extra_benefit_companys||[]
    },
    productList(){
      let {extra_benefit_names } = this.globalOptions||{}
      return extra_benefit_names ||[]
    },
    assgineeList(){
      let arr =[{id:0,name:'All'}]
      let {assignee=[]} = this.globalOptions||{}
      return [...arr,...assignee]
    },
    statusOptions() {
      return this.globalOptions.new_pcy_stts
    },
    effeOptions() {
      return this.globalOptions.effectiveness
    },
    tagsOptions() {
      return this.globalOptions.campaigns_tag
    },
    classTypeOptions(){
      return this.globalOptions.class_data||[]
    },
    classOptions(){
      return (index)=>{
        let arr = this.classTypeOptions||[]
        let data = []
        data = index==1? arr.filter(item =>item.id>50): arr.filter(item =>item.id<50)
        return data
      }
    },
    extra_tip(){
      return (row,index)=>{
        let textData = {}
        Object.entries(row).filter(item=>{
          if(item[1].id == index)
            textData = item[1]
        })
        if(textData)
          return textData.name

      }
    }
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        // if(!this.isFulfilled){
        let {extraList={}} =  this.selectFilterData||{}
        Object.keys(extraList).forEach(item=>{
          this[item] = extraList[item]
        })
        this.setFilterData(extraList||{})
        // }
        this.network().getExtraBenefitsList()
      }
    },
    date:{
      immediate: true,
      handler(){
        this.$emit('changeDate',this.date)
      }
    }
  },
  methods: {
    ...mapActions('filter', ['setFilterData']),
    rowClick(row) {
      const { pcy_id,id, class_id, product_id} = row
      //filter
      let params = {
        class_id:class_id,
        company_id:this.company_id,
        product_id: this.product_id,
        cs_id:this.cs_id,
        stts:this.stts,
        search: this.search,
        date:this.date,
        pageConfig:this.pageConfig,
        effe: this.effe,
      }
      this.setFilterData({extraList:params})
      this.$router.push({
        path:  product_id == 90? '/records/micropolicy/detail' : product_id > 50&&product_id<80? '/records/policy/manual/detail' :'/records/policy/detail',
        query: {
          id,
          product_id,
          pcy_id
        }
      })
    },
    clickPlanName(row){
      const { pcy_id,id, product_id } = row
      return ({
        path: product_id == 90? '/records/micropolicy/detail' : product_id > 50&&product_id<80? '/records/policy/manual/detail' :'/records/policy/detail',
        query: {
          id,
          product_id,
          pcy_id
        }
      })
    },
    handlerSelectAll(target) {
      let origin = ''
      switch(target) {
        case 'product_id':
          origin = 'classTypeOptions'
          break
        case 'campaign_id':
          origin = 'campaignList'
          break
        case 'stts':
          origin = 'statusOptions'
          break
        case 'effe':
          origin = 'effeOptions'
          break
        case 'tags':
          origin = 'tagsOptions'
          break
        case 'source':
          origin = 'channelList'
          break
        case 'company_id':
          origin = 'insurerAllOptions'
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[target] = data

      this.filterData()
    },
    handlerNoneAll(target){
      this[target] = []
      this.filterData()
    },
    changeDate(){
      this.$emit('changeDate',this.date)
      this.filterData()
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getExtraBenefitsList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getExtraBenefitsList()
    },
    hanldeImport(){
      this.$router.push({
        path: '/records/micropolicy/import-tracking-number'
      })
    },

    setExportStatus(val){
      this.exportDisable = val.length == 0
    },

    network() {
      return {
        getExtraBenefitsList: async () => {
          const { data } = await getExtraBenefitsList({
            created_start: this.date[0],
            created_end: this.date[1],
            nid: this.product_id,
            company_id: this.company_id,
            stts: this.stts,
            cs_id: this.cs_id,
            search: this.search,
            page: this.pageConfig.currentPage,
            effe_id: this.effe,
            source: this.source,
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
        getExtraBenefitsExportList: async () => {
          const {data}= await getExtraBenefitsExportList({
            created_start: this.date[0],
            created_end: this.date[1],
            nid: this.product_id,
            company_id: this.company_id,
            stts: this.stts,
            cs_id: this.cs_id,
            search: this.search,
            effe_id: this.effe,
            source: this.source,
            report_type:11
          })
          let {message}=data
          this.$message({
            type: 'success',
            message: 'Loading...'
          })
        }
      }
    },
    handlerDown() {
      this.network().getExtraBenefitsExportList()
    },
    handlerToExportList(){
      this.$router.push('/admin-cms/marketing-report?name=list')
    }
  }
}
</script>
<style lang="scss" scoped>
.page-container{
  position: relative;
  color: #303133;
  .payment-tips{
    width: 100%;
    height: 64px;
    background: #FFFBDD;
    border: 1px solid rgba(176, 136, 0, 0.2);
    border-radius: 6px;
    color: #24292E;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    .tips-icon{
      color: #B08800;
    }
    .left{
      padding-left: 16px;
      .tips-icon{
        margin-right: 16px;
      }
    }
    .right{
      padding-right: 18px;
    }
  }
  .flex-algin {
    /*display: flex;*/
    /*flex-direction: column;*/
    //justify-content: space-between;
    //font-weight: 500;
    &.time-text{
      font-size: 12px;
    }
    .icon-text{
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      letter-spacing: -0.15px;
      color: #24292E;
      margin-left: 15px;
    }
    .phone-text{
      font-size: 12px;
      color: #6A737D;
      .weight-text{
        font-weight: 600;
      }
    }
    &.period-text{
      span{
        font-size: 12px;
      }
    }
    p, span {
      min-height: 20px;
    }
    .first-text{
      color: #24292E;
      font-size: 14px;
    }
  }
  .table-icon{
    &.margin-top-flex{
      margin-top: 5px;
    }
    .icon{
      margin-right: 10px;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #e1e4e8;
    }
    .backgroud-width{
      background: #fff!important;
      border: 1px solid #e1e4e8;
    }
  }
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
  h1 {
    // margin-bottom: 20px;
    font-size: 34px;
  }
  .filter-container {
    .filter-box {
      margin-bottom: 10px;
      .label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: bold;
        .all {
          display: inline-block;
          padding-left: 15px;
          color: #409eff;
          font-weight: 500;
          cursor: pointer;
        }
      }
      .search-box {
        margin-right: 20px;
        width: 400px;
      }
      .quote-box {
        width: 300px;
      }
    }

  }
  .no-line{
    text-decoration: none;
  }
  .span-name {
    display: block;
    color: #24292E;
    height: auto!important;
    font-size: 14px;
    word-break: break-word;
  }
  .span-label {
    display: block;
    color: #24292E;
    font-weight: 600;
    word-break: break-word;
    font-size: 14px;
    text-decoration: none;
    &:hover{
      color:  #0366D6;
    }
  }
  .form-half {
    & > span {
      display: block;
      padding-bottom: 5px;
      font-size: 14px;
      color: #6a737d;
    }
  }
  .span-status, .span-options {
    display: inline-block;
    //margin-right: 15px;
    padding: 1px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    //text-overflow: ellipsis;
    //width: 120px;
    word-break:keep-all;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
  }
  .span-status{
    &.green {
      background: #28a745;
      color: white;
    }
    &.orange {
      background: #E36209;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.red {
      background: #d73a49;
    }
    &.min-green {
      background: #dcffe4;
      color: #28a745;
    }
  }
  .span-options{
    border: 1px solid;
    &.gray {
      border-color: #586069;
      color: #586069;
    }
    &.green {
      border-color: #22863A;
      color: #22863A;
    }
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
    &.gold {
      border-color: #735C0F;
      color: #735C0F;
    }
    &.blue {
      border-color: #0366D6;
      color: #0366D6;
    }
    &.orange {
      border-color: #C24E00;
      color: #C24E00;
    }
    &.black {
      border-color: #24292E;
      color: #24292E;
    }
  }
  .icon-color{
    &.gray {
      color: #586069;
    }
    &.green {
      color: #22863A;
    }
    &.red {
      color: #D73A49;
    }
  }
  .filter-card {
    margin-bottom: 15px;
    background: white;
    border: 1px solid #E1E4E8;
    border-radius: 5px;
    .filter-top {
      display: flex;
      align-items: center;
      padding: 15px;
      border-bottom: 1px solid #E1E4E8;
      & > span {
        display: inline-block;
        padding-right: 10px;
      }
    }
    .filter-main {
      display: flex;
      padding: 0 15px;
      .all {
        display: inline-block;
        padding-left: 15px;
        color: #409eff;
        cursor: pointer;
      }
      .filter-left, .filter-middler, .filter-right, .filter-last {
        padding: 15px 0;
      }
      .filter-left {
        padding-right: 10px;
        width: 290px;
        min-width: 290px;

      }
      .filter-middler {
        padding: 15px 10px;
        border-left: 1px solid #E1E4E8;
        border-right: 1px solid #E1E4E8;
        flex: 1;
      }
      .filter-right {
        padding-left: 10px;
        border-right: 1px solid #E1E4E8;
        flex: 1;
      }
      .filter-last{
        padding-left: 10px;
        flex: 1;
      }
    }
    .circle {
      display: inline-block;
      margin-right: 5px;
      width: 14px;
      height: 14px;
      min-width: 14px;
      min-height: 14px;
      border-radius: 100%;
      &.orange-light {
        background: #E36209;
      }
      &.yellow-dark {
        background: #DBAB09;
      }
      &.blue {
        background: #0366D6;
      }
      &.green {
        background: #28A745;
      }

      &.red {
        background: #D73A49;
      }
      &.gray{
        background: #6A737D;
      }
    }
  }
  .purple {
    background: #6F42C1;
  }
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
  ::v-deep .el-table{
    border-radius: 4px;
    border: 1px solid #E1E4E8;
    tr{
      td{
        //display: flex;
        padding: 10px 15px 10px 0!important;
        vertical-align: top;
        margin-right: 15px;
        //height: 40px;
        .cell{
          //min-height: 40px;
          line-height: 18px;
          position: relative;
          height: inherit;
          //margin-left: 10px;
          //margin-right: 10px;
          padding: 0;
          //padding: 5px 10px;
          //position: absolute;
          //top: 10px;
        }
      }
    }
    .table-pointer{
      cursor: pointer;
    }
  }
  ::v-deep .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    border-bottom: 1px solid #E1E4E8;

    th {
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      /* Text/text-gray-dark */
      padding: 10px 0!important;
      color: #24292E!important;
      .cell{
        padding-left: 0;
      }
    }
    .button-border{
      display: inline-block;
      padding: 0px 10px;
      height: auto;
      //line-height: 30px;
      font-size: 12px;
      border-radius: 50px;
      border: 1px solid #E1E4E8;
      color: #24292E;
      background: white;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 18px;

    }
  }
  .showLick{
    text-decoration: none;
  }
  .flex-algin {
    &.time-text{
      font-size: 12px;
    }
    .first-text{
      color: #24292E;
      font-size: 14px;
    }
    .summary{
      font-size: 12px;
      word-break: break-word;
    }
    .summary_rgtn_no{
      color: #6A737D;
      font-size: 12px;
      border: 1px solid #6A737D;
      border-radius: 4px;
      padding: 1px 4px;
    }
    .channel{
      font-size: 12px;
      font-weight: 600;
      color: #586069;
      margin: 5px 0;
      height: 18px;
      line-height: 18px;
    }
    .status-height{
      height: 23px;
    }
  }
}
</style>
